import React, { useEffect, useState, useRef } from "react";
import SubactivityList from "../../../components/Multi/Department-Subcategory/SubactivityList";
import SubHeader from "../../../components/Subheader/Subheader";
import { useSelector } from 'react-redux';
import CreateButton from "../../../components/Tools/CreateButton";
import CustomBreadcrumbs from "../../../components/Tools/Breadcumbs";

const SubactivityListPage = () => {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const fy_list = financialYears.payload.fy_list;
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const handlePageTrigger = () => {
    fyIdRef.current = localStorage.getItem('globalDateId');
  }

  return (
    <div>
      <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
      <div className="scheme p-2">
        <div className="row" style={{ padding: "10px 16px" }}>
            <div className="col-md-6">
                <h4 style={{ color: "#28326f", margin:0}}>Subactivities</h4>
                <CustomBreadcrumbs linksArray={[]} title="Subactivities"/>
            </div>
            <div className="col-md-6"></div>
        </div>
        <SubactivityList searchStr={""}/>
        { authData.user.user_type === 'l1' && <CreateButton title={"Add Subactivity"} url={"/department/add-subactivity"}/> }
      </div>
    </div>
  );
};
export default SubactivityListPage;
